import React from "react";
import {Icon} from "antd";

export const CommonLoader = ({ containerHeight, iconFontSize, iconColor, marginTop }) => {
  const style = { fontSize: iconFontSize, color: iconColor };
  if (marginTop) { style.marginTop = marginTop; }

  return (
    <div className={'flex justify-center items-center'}
         style={{height: containerHeight}}>
      <Icon type="sync" spin
            style={style}/>
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/components/common/CommonLoader.js